import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const CodeStep = ({ challenge, onDone, onCancel }) => {
  const { verifyCode } = useAuth();
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const signup = challenge.purpose === "signup";

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { onDone(await verifyCode(challenge.challenge_id, code)); } catch (e2) { setErr(formatApiError(e2)); } finally { setBusy(false); }
  };
  const resend = () => api.post("/auth/resend-code", { challenge_id: challenge.challenge_id })
    .then(() => toast.success("New code sent")).catch((e) => toast.error(formatApiError(e)));

  return (
    <form onSubmit={submit} className="w-full max-w-md space-y-6 rise" data-testid="mfa-form">
      <p className="eyebrow"><ShieldCheck className="w-3.5 h-3.5 mr-1.5" />{signup ? "Confirm your email" : "Two-step sign-in"}</p>
      <h1 className="font-serif-lux text-4xl sm:text-5xl">Check your email</h1>
      <p className="text-sm text-slate-400">We sent a 6-digit code to <span data-testid="mfa-email-hint" className="text-slate-200">{challenge.email_hint}</span>. It expires in 10 minutes.</p>
      <input data-testid="mfa-code-input" inputMode="numeric" autoComplete="one-time-code" maxLength={6} required autoFocus
        value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
        className="lux-input font-mono-lux text-2xl tracking-[0.5em] text-center" placeholder="••••••" />
      {err && <p data-testid="mfa-error" className="text-sm text-red-400">{err}</p>}
      <button data-testid="mfa-submit-btn" disabled={busy || code.length !== 6} className="btn-gold w-full py-3.5">{busy ? "Checking…" : signup ? "Confirm & create account" : "Verify & sign in"}</button>
      <div className="flex justify-between text-sm">
        <button type="button" data-testid="mfa-resend-btn" onClick={resend} className="text-[#38BDF8] hover:underline">Send a new code</button>
        <button type="button" data-testid="mfa-cancel-btn" onClick={onCancel} className="text-slate-400 hover:text-slate-200">Back</button>
      </div>
    </form>
  );
};
